import { render } from "./SearchExercisesFilterHorizontal.vue?vue&type=template&id=7ade87fc"
import script from "./SearchExercisesFilterHorizontal.vue?vue&type=script&lang=js"
export * from "./SearchExercisesFilterHorizontal.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/com.latudio.www.teachers_staging/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__